// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"463":"5e7c2f78","968":"7f305e85"}[chunkId] + ".css";
};